<div [class.hover]="hover$ | async">
  <router-outlet></router-outlet>
</div>

<span class="font-bold"></span>
